import http from "@/http";
//### 供应商列表
// addUserGroupAll
// https://zs.xzu.ink/api/item/list
export const getSupplier = {
  p: "/api/item/list",
  r: data => {
    return http({
      url: "/api/item/list",
      method: "post",
      data
    });
  }
};
//### 供应商详细信息
// https://zs.xzu.ink/api/item/details/1036
export const getSupplierInfo = {
  p: "/api/item/details",
  r: data => {
    return http({
      url: "/api/item/details/" + data.id,
      method: "get"
      // data
    });
  }
};
// ### 添加供应商
// https://zs.xzu.ink/api/item/add
export const addSupplier = {
  p: "/api/item/add",
  r: data => {
    return http({
      url: "/api/item/add",
      method: "post",
      data
    });
  }
};
//  ### 修改供应商
// https://zs.xzu.ink/api/item/update
export const editSupplier = {
  p: "/api/item/update",
  r: data => {
    return http({
      url: "/api/item/update",
      method: "post",
      data
    });
  }
};
//  ### 删除供应商
// https://zs.xzu.ink/api/item/delete
export const deleteSupplier = {
  p: "/api/item/delete",
  r: data => {
    return http({
      url: "/api/item/delete",
      method: "post",
      data
    });
  }
};
//  ### 获取供应商select选项
export const addSupplierselects = {
  p: "/api/item/all",
  r: data => {
    return http({
      url: "/api/item/selects",
      method: "get",
      data
    });
  }
};
